/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Smquizzesbody2Inputs */

const zh_landing_admin_smquizzesbody2 = /** @type {(inputs: Landing_Admin_Smquizzesbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检验学生掌握度`)
};

const en_landing_admin_smquizzesbody2 = /** @type {(inputs: Landing_Admin_Smquizzesbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test your students`)
};

const es_landing_admin_smquizzesbody2 = /** @type {(inputs: Landing_Admin_Smquizzesbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pon a prueba a tus estudiantes`)
};

/**
* | output |
* | --- |
* | "Test your students" |
*
* @param {Landing_Admin_Smquizzesbody2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_smquizzesbody2 = /** @type {((inputs?: Landing_Admin_Smquizzesbody2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Smquizzesbody2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_smquizzesbody2(inputs)
	if (locale === "en") return en_landing_admin_smquizzesbody2(inputs)
	return es_landing_admin_smquizzesbody2(inputs)
});
export { landing_admin_smquizzesbody2 as "landing_admin_smQuizzesBody" }